import { tv } from '~/utils/tv'

export const ToastRootVariants = tv({
  base: `
    flex flex-row h-large min-w-[256px] max-w-[768px] items-center border-quarterpulse border-border-neutral rounded-pill
    px-fourpulse gap-twopulse
  `,
  variants: {
    type: {
      neutral: 'bg-fill-neutral-alternative ',
      informative: 'bg-fill-informative-alternative ',
      success: 'bg-fill-success-alternative ',
      warning: 'bg-fill-warning-alternative ',
      danger: 'bg-fill-danger-alternative ',
    },
  },
})
